import React from 'react';
import './H1Title.css';

export default function H1Title(props) {
  let title = props.title;  
  return (
    <h1>{title}</h1>
  )
}
